export default __webpack_public_path__ + "static/media/profile.f42351c9.jpeg";